import React from 'react';
import { Settings, Cookie } from 'lucide-react';

const CookieSettingsButton = ({ onClick }) => {
  return (
    <button
      onClick={onClick}
      className="fixed left-4 bottom-4 z-40 bg-slate-900/90 backdrop-blur-md border border-slate-700/50 rounded-full p-3 shadow-lg hover:border-cyan-500/50 transition-all duration-300 hover:scale-110 group"
      aria-label="Configurações de Cookies"
      title="Gerenciar preferências de cookies"
    >
      <Cookie className="w-5 h-5 text-cyan-400 group-hover:rotate-12 transition-transform" />
      <span className="hidden lg:block absolute left-14 top-1/2 -translate-y-1/2 bg-slate-900 text-white px-3 py-2 rounded-lg text-sm whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none shadow-xl border border-slate-700">
        Gerenciar Cookies
      </span>
    </button>
  );
};

export default CookieSettingsButton;
